import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_FAILURE
} from '../constants'

export function* saveFastStockLoadingDataSaga({data:{saveData}}) {
  try {
      if(saveData){
          const result =  yield call(BFFAgent.Stock.TakingCarManagement.saveFastStockLoadingData, saveData)
          
          yield put({
              type: STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_SUCCESS,
              data: {...result, files: result.files || []}
          })
        } else {
          yield put({
            type: STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_FAILURE,
            data: { error : 'No se envió el objeto de datos' }
          })
        }
  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_SAVE_FAST_STOCK_LOADING_DATA_FAILURE,
      data: { error }
    })
  }
}
